// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__Vnuwe","dragIcon":"Choice_dragIcon__3yVD4","left":"Choice_left__lD3m6","input":"Choice_input__8cVa8"};